export const es = {
  customMessage: 'Hola mundo'
}



// WEBPACK FOOTER //
// ./src/customization/CustomPackage/lang/es.js